import { TarjetaHome } from 'src/app/shared/models/tarjeta-home.model';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
	selector: 'app-tarjeta',
	templateUrl: './tarjeta.component.html',
	styleUrls: ['./tarjeta.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TarjetaComponent implements OnInit {
	@Input() tarjeta: TarjetaHome;
	constructor() { }

	ngOnInit() {
	}
	viewDoc() {
		window.open(this.tarjeta.ruta_url);
	}
}
